var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import "../../../stylesheets/components/Features/LeadDashBoard/LeadDashBoard.scss";
import LeadData from "./LeadData";
import LeadViewTabs from "./LeadViewTabs";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import DateCalendar from "../../Generic/DateCalendar";
import { Col, Row } from "react-bootstrap";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import di from "./di/serviceLocator";
import { leadDashboardInitialPageSize, leadDashboardPageSize, } from "@domains/salesFeatures/Lead/entities/ILeadDashboardEntity";
import ToggleSwitch from "@frameworks/web/components/generic/SwitchButton/Switch";
import { EDataSource, EnumSalesFilter, } from "@domains/salesFeatures/Common/entities/IFilterDataEntity";
import { useSelector } from "react-redux";
import FilterState from "@frameworks/salesjourney/components/Home/filterState";
import filterDI from "@frameworks/salesjourney/components/filterDi/serviceLocator";
import { futureMonth, getDateInFormat, getFinancialYear, getStartAndEndDates, TodaysDate, } from "@domains/utils/reportDates";
import { useLocation, useNavigate } from "react-router-dom";
import SalesToasts from "../../../../shared-library/components/Toasts";
import filterDi from "@frameworks/salesjourney/components/filterDi/serviceLocator";
import { base64toExcel, getQueryParameterName, } from "@frameworks/salesjourney/utils/genericMethods";
import { followupCountList, removeTabs, } from "./constant";
import moment from "moment";
import { leadStatusConfig } from "@frameworks/salesjourney/utils/commonLeadStatusConfig";
import { LogoLoader } from "../../../../shared-library/components/Loader";
import LeadTableNPagination from "./LeadTableNPagination";
import { enabledLeaddashboardFilters, handleDisableFilter, } from "@frameworks/salesjourney/components/constant";
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
export var LeadTaskStatus;
(function (LeadTaskStatus) {
    LeadTaskStatus["OPEN"] = "OPEN";
    LeadTaskStatus["INPROCESS"] = "IN PROCESS";
    LeadTaskStatus["CONVERTED"] = "CONVERTED";
    LeadTaskStatus["NONCONVERTED"] = "NOT CONVERTED";
})(LeadTaskStatus || (LeadTaskStatus = {}));
var filterList = [
    {
        filter: "Lob",
        dataSource: EDataSource.LOB,
        value: EnumSalesFilter.lobId,
        inputType: "checkbox",
        //   onClick: onclick("lobId"),
        //   disabled: true,
        alternateValue: EnumSalesFilter.lobIdLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Sub Lob",
        dataSource: EDataSource.SUBLOB,
        value: EnumSalesFilter.sublobId,
        inputType: "checkbox",
        //   onClick: onclick("subLobId"),
        //   disabled: true,
        alternateValue: EnumSalesFilter.sublobIdLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Zone",
        dataSource: EDataSource.ZONE,
        value: EnumSalesFilter.zoneId,
        inputType: "checkbox",
        //   onClick: onclick("Zone"),
        //   disabled: false,
        alternateValue: EnumSalesFilter.zoneIdLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Region",
        dataSource: EDataSource.REGION,
        value: EnumSalesFilter.regionId,
        inputType: "checkbox",
        //   onClick: onclick("Region"),
        //   disabled: false,
        alternateValue: EnumSalesFilter.regionIdLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Branch",
        dataSource: EDataSource.BRANCH,
        value: EnumSalesFilter.branchId,
        inputType: "checkbox",
        //   onClick: onclick("Branch"),
        //   disabled: true,
        alternateValue: EnumSalesFilter.branchIdLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "RM",
        dataSource: EDataSource.RM,
        value: EnumSalesFilter.rmId,
        inputType: "checkbox",
        searchBox: true,
        searchValue: "",
        //   onClick: onclick("RM"),
        //   disabled: true,
        alternateValue: EnumSalesFilter.rmIdLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Role",
        dataSource: EDataSource.ROLE,
        value: EnumSalesFilter.role,
        inputType: "checkbox",
        //   onClick: onclick(""),
        //   disabled: true,
        alternateValue: EnumSalesFilter.roleLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Tier",
        dataSource: EDataSource.TIER,
        value: EnumSalesFilter.clientTier,
        inputType: "checkbox",
        //   disabled: false,
        alternateValue: EnumSalesFilter.clientTierLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Bucket",
        // dataSource: EDataSource.TIER,
        value: EnumSalesFilter.bucketId,
        inputType: "checkbox",
        //   disabled: false,
        alternateValue: EnumSalesFilter.bucketIdLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Scheme",
        // dataSource: EDataSource.TIER,
        value: EnumSalesFilter.displayId,
        inputType: "checkbox",
        searchBox: true,
        searchValue: "",
        //   disabled: false,
        dropDownList: [],
        alternateValue: EnumSalesFilter.schemeLst,
        externalDIFunction: filterDi.filter.getBucketDataActions,
        disabled: false,
    },
    {
        filter: "Cust Type",
        // dataSource: EDataSource.TIER,
        value: EnumSalesFilter.custType,
        inputType: "checkbox",
        //   disabled: false,
        alternateValue: EnumSalesFilter.custTypeLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Expiring",
        // dataSource: EDataSource.TIER,
        value: EnumSalesFilter.expiryId,
        alternateValue: EnumSalesFilter.expiryIdLst,
        inputType: "dropdown",
        //   disabled: false,
        dropDownList: [
            {
                title: "Today",
                value: "1",
                checked: false,
            },
            {
                title: "This Week",
                value: "2",
                checked: false,
            },
            {
                title: "This Month",
                value: "3",
                checked: false,
            },
            {
                title: "Expired",
                value: "4",
                checked: false,
            },
        ],
        disabled: false,
    },
    {
        filter: "Product",
        // dataSource: EDataSource.TIER,
        value: EnumSalesFilter.productId,
        searchBox: true,
        searchValue: "",
        inputType: "checkbox",
        //   disabled: false,
        alternateValue: EnumSalesFilter.productIdLst,
        dropDownList: [],
        isExternalApi: true,
        disabled: false,
    },
    {
        filter: "Mode",
        // dataSource: EDataSource.TIER,
        value: EnumSalesFilter.mode,
        inputType: "checkbox",
        //   disabled: false,
        alternateValue: EnumSalesFilter.modeLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Type",
        dataSource: EDataSource.TYPE,
        value: EnumSalesFilter.teamType,
        alternateValue: EnumSalesFilter.teamTypeLst,
        inputType: "checkbox",
        //   onClick: onclick(""),
        //   disabled: true,
        dropDownList: [],
        disabled: false,
        callAPIInsideOnChange: true,
    },
    {
        filter: "Status",
        // dataSource: EDataSource.TIER,
        value: EnumSalesFilter.status,
        inputType: "checkbox",
        //   disabled: false,
        alternateValue: EnumSalesFilter.statusLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Interaction Status",
        // dataSource: EDataSource.TIER,
        value: EnumSalesFilter.interactionStatus,
        inputType: "checkbox",
        //   disabled: false,
        alternateValue: EnumSalesFilter.interactionStatusLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Interaction Sub Status",
        // dataSource: EDataSource.TIER,
        value: EnumSalesFilter.interactionSubStatus,
        alternateValue: EnumSalesFilter.interactionSubStatusLst,
        inputType: "checkbox",
        //   disabled: false,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Participants",
        dataSource: EDataSource.Participant,
        value: EnumSalesFilter.participants,
        alternateValue: EnumSalesFilter.participantsLst,
        inputType: "checkbox",
        //   disabled: false,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Category",
        // dataSource: EDataSource.TIER,
        value: EnumSalesFilter.categoryId,
        searchBox: true,
        searchValue: "",
        inputType: "checkbox",
        //   disabled: false,
        alternateValue: EnumSalesFilter.categoryIdLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Comments",
        // dataSource: EDataSource.TIER,
        value: EnumSalesFilter.isCommented,
        inputType: "checkbox",
        isOnlyCheckbox: true,
        checkBoxText: "Commented By Me",
        //   disabled: false,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Source",
        // dataSource: EDataSource.TIER,
        value: EnumSalesFilter.sourceId,
        inputType: "dropdown",
        //   disabled: false,
        alternateValue: EnumSalesFilter.sourceIdLst,
        dropDownList: [],
    },
    {
        filter: "Sub Source",
        // dataSource: EDataSource.TIER,
        value: EnumSalesFilter.subSourceId,
        inputType: "checkbox",
        //   disabled: false,
        alternateValue: EnumSalesFilter.subSourceIdLst,
    },
    {
        filter: "Partners",
        dataSource: EDataSource.PARTNER,
        value: EnumSalesFilter.partnerId,
        inputType: "checkbox",
        searchBox: true,
        searchValue: "",
        alternateValue: EnumSalesFilter.partnerIdLst,
        dropDownList: [],
        disabled: false,
    },
    {
        filter: "Uncalled Leads",
        // dataSource: EDataSource.TIER,
        value: EnumSalesFilter.isUncalledLeads,
        inputType: "checkbox",
        isOnlyCheckbox: true,
        checkBoxText: "Uncalled Leads",
        //   disabled: false,
        dropDownList: [],
    },
    {
        filter: "Follow Up Count",
        value: EnumSalesFilter.followupCount,
        inputType: "dropdown",
        dropDownList: [
            {
                title: "1-3",
                value: "1-3",
                checked: false,
            },
            {
                title: "4-6",
                value: "4-6",
                checked: false,
            },
            {
                title: "7-9",
                value: "7-9",
                checked: false,
            },
            {
                title: ">9",
                value: "9",
                checked: false,
            },
        ],
    },
    {
        filter: "Lead Type",
        value: EnumSalesFilter.leadType,
        inputType: "dropdown",
        dropDownList: [
            {
                title: "Partner",
                value: "1",
                checked: false,
            },
            {
                title: "Client",
                value: "2",
                checked: false,
            },
        ],
    },
];
var LeadDashBoard = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var encodedFilterData = getQueryParameterName("filterData");
    var independentFlag360 = getQueryParameterName("independentFlag360");
    var criticalActivity = getQueryParameterName("criticalActivity");
    var searchText = getQueryParameterName("searchText");
    var isDateSkip = getQueryParameterName("isDateSkip");
    //const tabFlag = getQueryParameterName("tabFlag");
    var showWeek = getQueryParameterName("isShowWeek");
    var expired = getQueryParameterName("isExpiry");
    // const isExpiry = getQueryParameterName("isExpiry");
    var isRHAbove = localStorage.getItem(ELocalStorageKeys.IsRHAbove);
    var isView = getQueryParameterName("isView");
    var closed = getQueryParameterName("closed");
    var skipUpdateUrlQuery = getQueryParameterName("skipUpdateUrl");
    var isParenetIdClick = getQueryParameterName("isParenetIdClick");
    var _l = __read(React.useState(false), 2), parentIdClick = _l[0], setParentIdClick = _l[1];
    var _m = __read(React.useState(false), 2), skipUpdateUrl = _m[0], setSkipUpdateUrl = _m[1];
    var _o = __read(useState(getQueryParameterName("tabFlag")), 2), tabFlag = _o[0], setTabFlag = _o[1];
    var _p = __read(React.useState(false), 2), isSkip = _p[0], setIsSkip = _p[1];
    var retainedFilterData = useSelector(function (state) { return state.Common.filterDataReducer.finalFilterState; });
    var navigate = useNavigate();
    var location = useLocation();
    var locationState = location.state;
    var resetfilter = (_b = (_a = location === null || location === void 0 ? void 0 : location.state) === null || _a === void 0 ? void 0 : _a.reset) !== null && _b !== void 0 ? _b : null;
    var iamBack = (_d = (_c = location === null || location === void 0 ? void 0 : location.state) === null || _c === void 0 ? void 0 : _c.iamBack) !== null && _d !== void 0 ? _d : null;
    var leadTableTab = (_f = (_e = location === null || location === void 0 ? void 0 : location.state) === null || _e === void 0 ? void 0 : _e.leadTableTab) !== null && _f !== void 0 ? _f : null;
    var _q = __read(React.useState({
        fromDate: getDateInFormat(moment().startOf("month").toDate(), "YYYY/MM/DD"),
        toDate: getDateInFormat(moment().endOf("month").toDate(), "YYYY/MM/DD"),
    }), 2), dates = _q[0], setDates = _q[1];
    var _r = __read(React.useState(""), 2), leadIdSearch = _r[0], setLeadIdSearch = _r[1];
    var leadTabList = removeTabs();
    var _s = __read(React.useState(tabFlag ? tabFlag : leadTableTab !== null && leadTableTab !== void 0 ? leadTableTab : leadTabList[0].eventKey), 2), flag = _s[0], setFlag = _s[1];
    var _t = __read(useState(getQueryParameterName("isExpiry")), 2), isExpiry = _t[0], setIsExpiry = _t[1];
    var _u = __read(React.useState(), 2), querySearchText = _u[0], setQuerySearchText = _u[1];
    var _v = __read(React.useState(false), 2), filterSearch = _v[0], setFilterSearch = _v[1];
    var _w = __read(React.useState(false), 2), resetShowMonth = _w[0], setResetShowMonth = _w[1];
    var _x = __read(React.useState(handleDisableFilter(filterList, enabledLeaddashboardFilters)), 2), localFilterList = _x[0], setLocalFilterList = _x[1];
    var _y = __read(React.useState(true), 2), firstapiCall = _y[0], setfirstapiCall = _y[1];
    var _z = __read(React.useState(true), 2), showAllOpenLeads = _z[0], setShowAllOpenLeads = _z[1];
    var _0 = __read(React.useState(false), 2), resetAllMonth = _0[0], setResetAllMonth = _0[1];
    var _1 = __read(React.useState(""), 2), innerSearchText = _1[0], setInnerSearchText = _1[1];
    var _2 = __read(React.useState({}), 2), searchLeadDetail = _2[0], setSearchLeadDetail = _2[1];
    var _3 = __read(React.useState(false), 2), downloadLoader = _3[0], setDownloadLoader = _3[1];
    var getDefaultFilters = function () {
        if (!!isRHAbove && (isRHAbove === null || isRHAbove === void 0 ? void 0 : isRHAbove.length) > 0 && isRHAbove === "Y") {
            return {
                fromDate: getDateInFormat(moment().startOf("month").toDate(), "YYYY/MM/DD"),
                toDate: getDateInFormat(moment().endOf("month").toDate(), "YYYY/MM/DD"),
                teamType: [1, 2],
                isCommented: false,
                dataSource: EDataSource.TYPE,
            };
        }
        else {
            return {
                fromDate: getDateInFormat(moment().startOf("month").toDate(), "YYYY/MM/DD"),
                toDate: getDateInFormat(moment().endOf("month").toDate(), "YYYY/MM/DD"),
                teamType: [1],
                isCommented: false,
                dataSource: EDataSource.TYPE,
            };
        }
    };
    var _4 = __read(React.useState(getDefaultFilters()), 2), finalFilterState = _4[0], setFinalFilterState = _4[1];
    var _5 = __read(useState(false), 2), showSuccess = _5[0], setShowSuccess = _5[1];
    var _6 = __read(useState(false), 2), filterLoader = _6[0], setFilterLoader = _6[1];
    useEffect(function () {
        if (expired !== undefined && expired !== null && expired !== "") {
            setIsExpiry(expired);
        }
    }, [expired]);
    var dateChangeFilterData = function (startDate, endDate, showMonth, showWeek) {
        setResetAllMonth(false);
        setFinalFilterState(function (finalFilterState) {
            finalFilterState.fromDate = moment(startDate).format("YYYY/MM/DD");
            finalFilterState.toDate = moment(endDate).format("YYYY/MM/DD");
            (finalFilterState.showMonth = showMonth),
                (finalFilterState.showWeek = showWeek);
            onSubmit(finalFilterState, true);
            // filterDI.filter.updateFinalFilterState(finalFilterState);
            return finalFilterState;
        });
    };
    var _7 = __read(useState(true), 2), isShowNewFilterDesign = _7[0], setIsShowNewFilterDesign = _7[1];
    var _8 = __read(useState([]), 2), displayBubbleFilters = _8[0], setDisplayBubbleFilters = _8[1];
    var _9 = __read(React.useState(false), 2), isShowFilterSidebar = _9[0], setIsShowFilterSidebar = _9[1];
    var updateInputSearch = function (searchText, isEnterKey, onParentIdClick) {
        var localFinalFilterState = {};
        if (parentIdClick &&
            encodedFilterData &&
            (encodedFilterData === null || encodedFilterData === void 0 ? void 0 : encodedFilterData.length) > 0 &&
            (searchText === null || searchText === void 0 ? void 0 : searchText.length) === 0) {
            localFinalFilterState = JSON.parse(encodedFilterData);
            var fromDate_1 = "", toDate_1 = "";
            if (localFinalFilterState.fromDate && localFinalFilterState.toDate) {
                localFinalFilterState.fromDate = getDateInFormat(localFinalFilterState.fromDate, "YYYY/MM/DD");
                localFinalFilterState.toDate = getDateInFormat(localFinalFilterState.toDate, "YYYY/MM/DD");
                fromDate_1 = localFinalFilterState.fromDate;
                toDate_1 = localFinalFilterState.toDate;
                setDates(function (localDates) {
                    localDates.toDate = toDate_1;
                    localDates.fromDate = fromDate_1;
                    return localDates;
                });
                setIsSkip(true);
            }
            else {
                localFinalFilterState.toDate = getDateInFormat(moment().endOf("month").toDate(), "YYYY/MM/DD");
                localFinalFilterState.fromDate = getDateInFormat(moment().startOf("month").toDate(), "YYYY/MM/DD");
            }
            if (closed && closed !== "") {
                if (closed === "Y") {
                    setClosedLead(true);
                    getLeadDBSummary(LeadTaskStatus.CONVERTED, setleadDBSummaryConverted);
                    getLeadDBSummary(LeadTaskStatus.NONCONVERTED, setleadDBSummaryNonConverted);
                }
                else {
                    setClosedLead(false);
                    getLeadDBSummary(LeadTaskStatus.OPEN, setleadDBSummaryOpen);
                    getLeadDBSummary(LeadTaskStatus.INPROCESS, setleadDBSummaryInProcess);
                }
            }
            displayBubbles(localFinalFilterState);
            getLeadDashboardData(flag, false, localFinalFilterState, isDateSkip && isDateSkip === "true" ? true : false);
            setParentIdClick(false);
        }
        else {
            localFinalFilterState = __assign(__assign({}, finalFilterState), { pan: searchText, mobileNo: searchText, clientName: searchText, email: searchText, leadId: searchText });
            if (EnumSalesFilter.leadType in localFinalFilterState) {
                delete localFinalFilterState.leadType;
            }
            if (onParentIdClick) {
                localFinalFilterState.status = [
                    leadStatusConfig.openStatusIdForLeadFilter,
                    leadStatusConfig.inProcessStatusIdForLeadFilter,
                    leadStatusConfig.convertedStatusIdForLeadFilter,
                    leadStatusConfig.nonConvertedStatusIdForLeadFilter,
                ];
                (localFinalFilterState.searchFlagNew = ""),
                    (localFinalFilterState.statusLst = [
                        {
                            id: leadStatusConfig.openStatusIdObject.id,
                            parentFilter: EnumSalesFilter.status,
                            checked: true,
                            inputType: "checkbox",
                            filterKey: EnumSalesFilter.statusLst,
                            name: leadStatusConfig.openStatusIdObject.name,
                        },
                        {
                            id: leadStatusConfig.inProcessStatusIdObject.id,
                            parentFilter: EnumSalesFilter.status,
                            checked: true,
                            inputType: "checkbox",
                            filterKey: EnumSalesFilter.statusLst,
                            name: leadStatusConfig.inProcessStatusIdObject.name,
                        },
                        {
                            id: leadStatusConfig.convertedStatusIdObject.id,
                            parentFilter: EnumSalesFilter.status,
                            checked: true,
                            inputType: "checkbox",
                            filterKey: EnumSalesFilter.statusLst,
                            name: leadStatusConfig.convertedStatusIdObject.name,
                        },
                        {
                            id: leadStatusConfig.notConvertedStatusIdObject.id,
                            parentFilter: EnumSalesFilter.status,
                            checked: true,
                            inputType: "checkbox",
                            filterKey: EnumSalesFilter.statusLst,
                            name: leadStatusConfig.notConvertedStatusIdObject.name,
                        },
                    ]);
                displayBubbles(localFinalFilterState);
            }
        }
        setFinalFilterState(localFinalFilterState);
        if (isEnterKey)
            onSubmit(localFinalFilterState);
    };
    var updateLeadDashboardURL = function (value) {
        if (parentIdClick) {
            var url = new URL(window.location.href);
            url.searchParams.delete("isParenetIdClick");
        }
        else if (!!isView &&
            isView === "Y" &&
            (value === null ||
                value === undefined ||
                (value === null || value === void 0 ? void 0 : value.length) === 0 ||
                value === "")) {
            navigate("/dashboard/lead-dashboard", { replace: true });
            setFinalFilterState({});
            setDisplayBubbleFilters([]);
            setLocalFilterList(function (localFilterList) {
                localFilterList = localFilterList.map(function (x) {
                    if (x.value !== EnumSalesFilter.followupCount) {
                        x.dropDownList = [];
                    }
                    return x;
                });
                return localFilterList;
            });
            //setResetShowWeek(true);
            setDates({
                fromDate: getDateInFormat(moment().startOf("month").toDate(), "YYYY/MM/DD"),
                toDate: getDateInFormat(moment().endOf("month").toDate(), "YYYY/MM/DD"),
            });
            var localFinalFilterState = {
                fromDate: getDateInFormat(moment().startOf("month").toDate(), "YYYY/MM/DD"),
                toDate: getDateInFormat(moment().endOf("month").toDate(), "YYYY/MM/DD"),
                status: closedLead
                    ? [
                        leadStatusConfig.convertedStatusIdForLeadFilter,
                        leadStatusConfig.nonConvertedStatusIdForLeadFilter,
                    ]
                    : [
                        leadStatusConfig.openStatusIdForLeadFilter,
                        leadStatusConfig.inProcessStatusIdForLeadFilter,
                    ],
                teamType: [1],
            };
            localFinalFilterState.isUncalledLeads = false;
            localFinalFilterState.statusLst = [];
            localFinalFilterState.teamTypeLst = [];
            initialDisplayBubbles(localFinalFilterState, true, true);
            setFinalFilterState(localFinalFilterState);
        }
    };
    React.useEffect(function () {
        if (tabFlag || leadTableTab) {
            setFlag(tabFlag !== null && tabFlag !== void 0 ? tabFlag : leadTableTab);
        }
    }, [tabFlag, leadTableTab]);
    var _10 = __read(useState(0), 2), scrollPosition = _10[0], setScrollPosition = _10[1];
    React.useEffect(function () {
        if (!!skipUpdateUrlQuery && skipUpdateUrlQuery === "true") {
            setSkipUpdateUrl(true);
        }
    }, [skipUpdateUrlQuery]);
    React.useEffect(function () {
        if (!!isParenetIdClick && isParenetIdClick === "true") {
            setParentIdClick(true);
        }
    }, [isParenetIdClick]);
    React.useEffect(function () {
        var _a;
        var commonFunction = function (localFinalFilterState) {
            var _a, _b, _c;
            var fromDate = "", toDate = "";
            if (localFinalFilterState.fromDate && localFinalFilterState.toDate) {
                localFinalFilterState.fromDate = getDateInFormat(localFinalFilterState.fromDate, "YYYY/MM/DD");
                localFinalFilterState.toDate = getDateInFormat(localFinalFilterState.toDate, "YYYY/MM/DD");
                fromDate = localFinalFilterState.fromDate;
                toDate = localFinalFilterState.toDate;
                setDates(function (localDates) {
                    localDates.toDate = toDate;
                    localDates.fromDate = fromDate;
                    return localDates;
                });
                setIsSkip(true);
            }
            else {
                // console.log("datehgfctfu", localFinalFilterState);
                localFinalFilterState.toDate = getDateInFormat(moment().endOf("month").toDate(), "YYYY/MM/DD");
                localFinalFilterState.fromDate = getDateInFormat(moment().startOf("month").toDate(), "YYYY/MM/DD");
            }
            setShowAllOpenLeads(!!(localFinalFilterState === null || localFinalFilterState === void 0 ? void 0 : localFinalFilterState.showAllOpenLeads));
            // for pipeline aging leads
            if (!!(localFinalFilterState === null || localFinalFilterState === void 0 ? void 0 : localFinalFilterState.dcf) ||
                !!(localFinalFilterState === null || localFinalFilterState === void 0 ? void 0 : localFinalFilterState.icf) ||
                !!(localFinalFilterState === null || localFinalFilterState === void 0 ? void 0 : localFinalFilterState.remap)) {
                localFinalFilterState.teamType = [1];
                localFinalFilterState.teamTypeLst = [
                    {
                        id: leadStatusConfig.selfTeamObject.id,
                        parentFilter: EnumSalesFilter.teamType,
                        checked: true,
                        inputType: "checkbox",
                        filterKey: EnumSalesFilter.teamTypeLst,
                        name: leadStatusConfig.selfTeamObject.name,
                    },
                ];
                (localFinalFilterState.status = [1, 2]),
                    (localFinalFilterState.statusLst = [
                        {
                            id: leadStatusConfig.openStatusIdForLeadFilter,
                            parentFilter: EnumSalesFilter.status,
                            checked: true,
                            inputType: "checkbox",
                            filterKey: EnumSalesFilter.statusLst,
                            name: leadStatusConfig.openStatusIdObject.name,
                        },
                        {
                            id: leadStatusConfig.inProcessStatusIdForLeadFilter,
                            parentFilter: EnumSalesFilter.status,
                            checked: true,
                            inputType: "checkbox",
                            filterKey: EnumSalesFilter.statusLst,
                            name: leadStatusConfig.inProcessStatusIdObject.name,
                        },
                    ]);
            }
            if (((_a = localFinalFilterState === null || localFinalFilterState === void 0 ? void 0 : localFinalFilterState.categoryId) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                !!localFinalFilterState.categoryIdLst &&
                (localFinalFilterState === null || localFinalFilterState === void 0 ? void 0 : localFinalFilterState.categoryIdLst.length) == 0 &&
                (localFinalFilterState === null || localFinalFilterState === void 0 ? void 0 : localFinalFilterState.categoryId[0]) ===
                    (leadStatusConfig === null || leadStatusConfig === void 0 ? void 0 : leadStatusConfig.investmentProductIdObj.id)) {
                localFinalFilterState.categoryIdLst = [
                    {
                        id: leadStatusConfig === null || leadStatusConfig === void 0 ? void 0 : leadStatusConfig.investmentProductIdObj.id,
                        parentFilter: EnumSalesFilter.categoryId,
                        checked: true,
                        inputType: "checkbox",
                        filterKey: EnumSalesFilter.categoryIdLst,
                        name: leadStatusConfig === null || leadStatusConfig === void 0 ? void 0 : leadStatusConfig.investmentProductIdObj.name,
                    },
                ];
            }
            if (!!(localFinalFilterState === null || localFinalFilterState === void 0 ? void 0 : localFinalFilterState.searchFlag) &&
                ((_b = localFinalFilterState === null || localFinalFilterState === void 0 ? void 0 : localFinalFilterState.searchFlag) === null || _b === void 0 ? void 0 : _b.length) > 0 &&
                (localFinalFilterState === null || localFinalFilterState === void 0 ? void 0 : localFinalFilterState.searchFlag) === "pipelinesummary") {
                localFinalFilterState.participantsLst = [];
                localFinalFilterState.participantsLst = [
                    {
                        id: leadStatusConfig.leadOwnerFilterSourceObj.id,
                        parentFilter: EnumSalesFilter.participants,
                        checked: true,
                        inputType: "checkbox",
                        filterKey: EnumSalesFilter.participantsLst,
                        name: leadStatusConfig.leadOwnerFilterSourceObj.name,
                    },
                    {
                        id: leadStatusConfig.primaryOwnerFilterSource.id,
                        parentFilter: EnumSalesFilter.participants,
                        checked: true,
                        inputType: "checkbox",
                        filterKey: EnumSalesFilter.participantsLst,
                        name: leadStatusConfig.primaryOwnerFilterSource.name,
                    },
                ];
            }
            if (!!localFinalFilterState.searchFlagNew &&
                ((_c = localFinalFilterState === null || localFinalFilterState === void 0 ? void 0 : localFinalFilterState.searchFlagNew) === null || _c === void 0 ? void 0 : _c.length) > 0 &&
                ((localFinalFilterState === null || localFinalFilterState === void 0 ? void 0 : localFinalFilterState.searchFlagNew) == "allp" ||
                    (localFinalFilterState === null || localFinalFilterState === void 0 ? void 0 : localFinalFilterState.searchFlagNew) == "all")) {
                localFinalFilterState.statusLst = [];
                localFinalFilterState.statusLst.push({
                    id: leadStatusConfig.openStatusIdObject.id,
                    parentFilter: EnumSalesFilter.status,
                    checked: true,
                    inputType: "checkbox",
                    filterKey: EnumSalesFilter.statusLst,
                    name: leadStatusConfig.openStatusIdObject.name,
                }, {
                    id: leadStatusConfig.inProcessStatusIdObject.id,
                    parentFilter: EnumSalesFilter.status,
                    checked: true,
                    inputType: "checkbox",
                    filterKey: EnumSalesFilter.statusLst,
                    name: leadStatusConfig.inProcessStatusIdObject.name,
                }, {
                    id: leadStatusConfig.convertedStatusIdObject.id,
                    parentFilter: EnumSalesFilter.status,
                    checked: true,
                    inputType: "checkbox",
                    filterKey: EnumSalesFilter.statusLst,
                    name: leadStatusConfig.convertedStatusIdObject.name,
                }, {
                    id: leadStatusConfig.notConvertedStatusIdObject.id,
                    parentFilter: EnumSalesFilter.status,
                    checked: true,
                    inputType: "checkbox",
                    filterKey: EnumSalesFilter.statusLst,
                    name: leadStatusConfig.notConvertedStatusIdObject.name,
                });
            }
            if (closed && closed !== "") {
                if (closed === "Y") {
                    setClosedLead(true);
                    getLeadDBSummary(LeadTaskStatus.CONVERTED, setleadDBSummaryConverted);
                    getLeadDBSummary(LeadTaskStatus.NONCONVERTED, setleadDBSummaryNonConverted);
                }
                else {
                    setClosedLead(false);
                    getLeadDBSummary(LeadTaskStatus.OPEN, setleadDBSummaryOpen);
                    getLeadDBSummary(LeadTaskStatus.INPROCESS, setleadDBSummaryInProcess);
                }
            }
            displayBubbles(localFinalFilterState);
            setFinalFilterState(localFinalFilterState);
            getLeadDashboardData(flag, false, localFinalFilterState, isDateSkip && isDateSkip === "true" ? true : false);
        };
        if (searchText &&
            (searchText === null || searchText === void 0 ? void 0 : searchText.length) > 0 &&
            ((_a = window.atob(searchText)) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            setQuerySearchText(window.atob(searchText));
            var localFilterState_1 = {};
            localFilterState_1.teamType = [1, 2];
            localFilterState_1.teamTypeLst = [
                {
                    id: leadStatusConfig.selfTeamObject.id,
                    parentFilter: EnumSalesFilter.teamType,
                    checked: true,
                    inputType: "checkbox",
                    filterKey: EnumSalesFilter.teamTypeLst,
                    name: leadStatusConfig.selfTeamObject.name,
                },
                {
                    id: leadStatusConfig.teamTypeObject.id,
                    parentFilter: EnumSalesFilter.teamType,
                    checked: true,
                    inputType: "checkbox",
                    filterKey: EnumSalesFilter.teamTypeLst,
                    name: leadStatusConfig.teamTypeObject.name,
                },
            ];
            localFilterState_1.status = [];
            localFilterState_1.status = [
                leadStatusConfig.openStatusIdForLeadFilter,
                leadStatusConfig.inProcessStatusIdForLeadFilter,
                leadStatusConfig.convertedStatusIdForLeadFilter,
                leadStatusConfig.nonConvertedStatusIdForLeadFilter,
            ];
            localFilterState_1.statusLst = [];
            if (!!isView && (isView === null || isView === void 0 ? void 0 : isView.length) > 0) {
                localFilterState_1.isView = isView === "Y" ? true : false;
            }
            localFilterState_1.statusLst.push({
                id: leadStatusConfig.openStatusIdObject.id,
                parentFilter: EnumSalesFilter.status,
                checked: true,
                inputType: "checkbox",
                filterKey: EnumSalesFilter.statusLst,
                name: leadStatusConfig.openStatusIdObject.name,
            }, {
                id: leadStatusConfig.inProcessStatusIdObject.id,
                parentFilter: EnumSalesFilter.status,
                checked: true,
                inputType: "checkbox",
                filterKey: EnumSalesFilter.statusLst,
                name: leadStatusConfig.inProcessStatusIdObject.name,
            }, {
                id: leadStatusConfig.convertedStatusIdObject.id,
                parentFilter: EnumSalesFilter.status,
                checked: true,
                inputType: "checkbox",
                filterKey: EnumSalesFilter.statusLst,
                name: leadStatusConfig.convertedStatusIdObject.name,
            }, {
                id: leadStatusConfig.notConvertedStatusIdObject.id,
                parentFilter: EnumSalesFilter.status,
                checked: true,
                inputType: "checkbox",
                filterKey: EnumSalesFilter.statusLst,
                name: leadStatusConfig.notConvertedStatusIdObject.name,
            });
            setFinalFilterState(function (finalFilterState) {
                finalFilterState = localFilterState_1;
                return finalFilterState;
            });
            updateInputSearch(window.atob(searchText), true);
            displayBubbles(localFilterState_1);
        }
        else if (isExpiry === "true") {
            var localFilterState = {};
            localFilterState.expiryId = "2";
            localFilterState.ExpiryfromDate = getDateInFormat(getStartAndEndDates("day").endDate, "YYYY/MM/DD");
            localFilterState.ExpirytoDate = getDateInFormat(moment().endOf("isoWeek").toDate(), "YYYY/MM/DD");
            localFilterState.expiryIdLst = [
                {
                    id: 2,
                    name: "This Week",
                    parentFilter: EnumSalesFilter.expiryId,
                    inputType: "dropdown",
                    checked: true,
                },
            ];
            setShowAllOpenLeads(false);
            displayBubbles(localFilterState);
            setFinalFilterState(localFilterState);
            di.leads.paginationResetOnFilterApply(true);
            // filterDI.filter.updateFinalFilterState(localFilterState);
            getLeadDashboardData("2", false, null, false, isExpiry ? true : false);
        }
        else if (encodedFilterData) {
            var localFinalFilterState = JSON.parse(encodedFilterData);
            if (independentFlag360 !== "true" &&
                !(localFinalFilterState === null || localFinalFilterState === void 0 ? void 0 : localFinalFilterState.remap) &&
                !(localFinalFilterState === null || localFinalFilterState === void 0 ? void 0 : localFinalFilterState.dcf) &&
                !(localFinalFilterState === null || localFinalFilterState === void 0 ? void 0 : localFinalFilterState.icf) &&
                criticalActivity !== "true") {
                localFinalFilterState = __assign(__assign({}, retainedFilterData), localFinalFilterState);
            }
            // filterDI.filter.updateFinalFilterState(localFinalFilterState);
            commonFunction(localFinalFilterState);
        }
        else {
            var fromDate = getDateInFormat(moment().startOf("month").toDate(), "YYYY/MM/DD"), toDate = getDateInFormat(moment().endOf("month").toDate(), "YYYY/MM/DD");
            setDates({ fromDate: fromDate, toDate: toDate });
            var localFinalFilterState_1 = {
                pan: "",
                mobileNo: "",
                clientName: "",
                email: "",
                leadId: "",
                fromDate: fromDate,
                toDate: toDate,
                status: [
                    leadStatusConfig.openStatusIdForLeadFilter,
                    leadStatusConfig.inProcessStatusIdForLeadFilter,
                ],
                teamType: !!isRHAbove && (isRHAbove === null || isRHAbove === void 0 ? void 0 : isRHAbove.length) > 0 && isRHAbove === "Y"
                    ? [1, 2]
                    : [1],
                teamTypeLst: [],
                statusLst: [],
                isCommented: false,
                isUncalledLeads: false,
                dataSource: EDataSource.TYPE,
            };
            if (iamBack) {
                localFinalFilterState_1 = {};
            }
            if (resetfilter) {
                setShowAllOpenLeads(function (showAllOpenLeads) {
                    showAllOpenLeads = true;
                    localFinalFilterState_1.showAllOpenLeads = true;
                    return showAllOpenLeads;
                });
                resetFunction(true);
            }
            else {
                if (firstapiCall)
                    initialDisplayBubbles(localFinalFilterState_1, false);
            }
        }
    }, [encodedFilterData, isExpiry, searchText]);
    var initialDisplayBubbles = function (localFinalFilterState, isReset, skipApiCall) {
        var _a, _b, _c, _d;
        if (((_a = localFinalFilterState === null || localFinalFilterState === void 0 ? void 0 : localFinalFilterState.teamType) === null || _a === void 0 ? void 0 : _a.length) &&
            ((_b = localFinalFilterState === null || localFinalFilterState === void 0 ? void 0 : localFinalFilterState.status) === null || _b === void 0 ? void 0 : _b.length)) {
            if (!!isRHAbove && (isRHAbove === null || isRHAbove === void 0 ? void 0 : isRHAbove.length) > 0 && isRHAbove === "Y") {
                localFinalFilterState.teamTypeLst.push({
                    id: leadStatusConfig.selfTeamObject.id,
                    parentFilter: EnumSalesFilter.teamType,
                    checked: true,
                    inputType: "checkbox",
                    filterKey: EnumSalesFilter.teamTypeLst,
                    name: leadStatusConfig.selfTeamObject.name,
                }, {
                    id: leadStatusConfig.teamTypeObject.id,
                    parentFilter: EnumSalesFilter.teamType,
                    checked: true,
                    inputType: "checkbox",
                    filterKey: EnumSalesFilter.teamTypeLst,
                    name: leadStatusConfig.teamTypeObject.name,
                });
            }
            else {
                localFinalFilterState.teamTypeLst.push({
                    id: leadStatusConfig.selfTeamObject.id,
                    parentFilter: EnumSalesFilter.teamType,
                    checked: true,
                    inputType: "checkbox",
                    filterKey: EnumSalesFilter.teamTypeLst,
                    name: leadStatusConfig.selfTeamObject.name,
                });
            }
            localFinalFilterState.statusLst.push({
                id: leadStatusConfig.openStatusIdForLeadFilter,
                parentFilter: EnumSalesFilter.status,
                checked: true,
                inputType: "checkbox",
                filterKey: EnumSalesFilter.statusLst,
                name: leadStatusConfig.openStatusIdObject.name,
            });
            localFinalFilterState.statusLst.push({
                id: leadStatusConfig.inProcessStatusIdForLeadFilter,
                parentFilter: EnumSalesFilter.status,
                checked: true,
                inputType: "checkbox",
                filterKey: EnumSalesFilter.statusLst,
                name: leadStatusConfig.inProcessStatusIdObject.name,
            });
        }
        setFilterLoader(true);
        setFinalFilterState(function (finalFilterState) {
            if (!!finalFilterState.expiryId) {
                if (finalFilterState.expiryId === "1") {
                    finalFilterState.ExpiryfromDate = getDateInFormat(getStartAndEndDates("day").startDate, "YYYY/MM/DD");
                    finalFilterState.ExpirytoDate = getDateInFormat(getStartAndEndDates("day").endDate, "YYYY/MM/DD");
                }
                else if (finalFilterState.expiryId === "2") {
                    //week will use for the from start sunday to saturday and isoWeek will use for the from start monday to sunday.
                    finalFilterState.ExpiryfromDate = getDateInFormat(getStartAndEndDates("isoWeek").startDate, "YYYY/MM/DD");
                    finalFilterState.ExpirytoDate = getDateInFormat(getStartAndEndDates("isoWeek").endDate, "YYYY/MM/DD");
                }
                else if (finalFilterState.expiryId === "3") {
                    finalFilterState.ExpiryfromDate = getDateInFormat(getStartAndEndDates("month").startDate, "YYYY/MM/DD");
                    finalFilterState.ExpirytoDate = getDateInFormat(getStartAndEndDates("month").endDate, "YYYY/MM/DD");
                }
            }
            return finalFilterState;
        });
        if (retainedFilterData &&
            Object.keys(retainedFilterData).length > 1 &&
            !isReset) {
            localFinalFilterState = __assign(__assign({}, localFinalFilterState), retainedFilterData);
        }
        displayBubbles(localFinalFilterState);
        // filterDI.filter.updateFinalFilterState(localFinalFilterState);
        setScrollPosition(window.pageYOffset);
        di.leads.paginationResetOnFilterApply(true);
        setFinalFilterState(localFinalFilterState);
        if (skipApiCall) {
        }
        else {
            getLeadDashboardData(flag, false, localFinalFilterState);
        }
        setFinalFilterState(localFinalFilterState);
        if (((_c = localFinalFilterState === null || localFinalFilterState === void 0 ? void 0 : localFinalFilterState.status) === null || _c === void 0 ? void 0 : _c.includes(3)) ||
            ((_d = localFinalFilterState === null || localFinalFilterState === void 0 ? void 0 : localFinalFilterState.status) === null || _d === void 0 ? void 0 : _d.includes(4))) {
            setClosedLead(true);
            getLeadDBSummary(LeadTaskStatus.CONVERTED, setleadDBSummaryConverted);
            getLeadDBSummary(LeadTaskStatus.NONCONVERTED, setleadDBSummaryNonConverted);
        }
        else {
            setClosedLead(false);
            getLeadDBSummary(LeadTaskStatus.OPEN, setleadDBSummaryOpen);
            getLeadDBSummary(LeadTaskStatus.INPROCESS, setleadDBSummaryInProcess);
        }
    };
    useEffect(function () {
        if (locationState === null || locationState === void 0 ? void 0 : locationState.show) {
            setShowSuccess(true);
            locationState = {};
        }
        else {
            setShowSuccess(false);
        }
    }, [location.state]);
    var displayBubbles = function (finalFilterState) {
        Object.keys(finalFilterState).forEach(function (filterKey) {
            var _a;
            if (/Lst/.test(filterKey)) {
                finalFilterState[filterKey].forEach(function (item) {
                    setDisplayBubbleFilters(function (prevState) {
                        var tempArr = __spreadArray([], __read(prevState), false);
                        var isItemPresentInBubbles = tempArr.findIndex(function (bubbleObj) { return bubbleObj.name === item.name; });
                        if (isItemPresentInBubbles < 0) {
                            if (filterKey === EnumSalesFilter.teamTypeLst)
                                item.callAPIInsideOnChange = true;
                            tempArr.push(item);
                        }
                        return tempArr;
                    });
                });
            }
            else if (filterKey === EnumSalesFilter.isCommented &&
                finalFilterState.isCommented) {
                setDisplayBubbleFilters(function (prevState) {
                    var tempArr = __spreadArray([], __read(prevState), false);
                    tempArr.push({
                        id: 101,
                        name: "Commented By Me",
                        parentFilter: "Comments",
                        inputType: "checkbox",
                        checked: finalFilterState === null || finalFilterState === void 0 ? void 0 : finalFilterState.isCommented,
                        isBooleanField: true,
                    });
                    return tempArr;
                });
            }
            else if (filterKey === EnumSalesFilter.followupCount &&
                finalFilterState[filterKey] !== null &&
                finalFilterState[filterKey] !== undefined &&
                finalFilterState[filterKey] !== "") {
                // let index = localFilterList.findIndex((x) => x.value === filterKey);
                // let selectedValueIndex = localFilterList[index].dropDownList.findIndex(
                //   (x: IFilterlist) =>
                //     x.value === finalFilterState[filterKey]?.toString()
                // );
                // let selectedFollowUpCount = localFilterList[index].dropDownList.find(
                //   (x: IFilterlist) =>
                //     x.value === finalFilterState[filterKey]?.toString()
                // );
                var selectedFollowUpCount_1 = followupCountList.find(function (x) { var _a; return x.value === ((_a = finalFilterState[filterKey]) === null || _a === void 0 ? void 0 : _a.toString()); });
                // let selectedObj =
                //   localFilterList[index].dropDownList[selectedValueIndex];
                // console.log(
                //   "line549",
                //   finalFilterState[filterKey],
                //   selectedObj,
                //   selectedFollowUpCount
                // );
                setDisplayBubbleFilters(function (prevState) {
                    var tempArr = __spreadArray([], __read(prevState), false);
                    tempArr.push({
                        id: parseInt(finalFilterState[filterKey]),
                        name: selectedFollowUpCount_1 === null || selectedFollowUpCount_1 === void 0 ? void 0 : selectedFollowUpCount_1.title,
                        parentFilter: EnumSalesFilter.followupCount,
                        inputType: "dropdown",
                        checked: true,
                    });
                    return tempArr;
                });
            }
            else if (filterKey === EnumSalesFilter.isUncalledLeads &&
                finalFilterState.isUncalledLeads) {
                setDisplayBubbleFilters(function (prevState) {
                    var tempArr = __spreadArray([], __read(prevState), false);
                    tempArr.push({
                        id: 102,
                        name: "Uncalled Leads",
                        parentFilter: "Uncalled Leads",
                        inputType: "checkbox",
                        checked: finalFilterState === null || finalFilterState === void 0 ? void 0 : finalFilterState.isUncalledLeads,
                        isBooleanField: true,
                    });
                    return tempArr;
                });
                // } else if (filterKey === EnumSalesFilter.expiryId) {
                //   // let index = localFilterList.findIndex(
                //   //   (x: any) => x.value === filterKey
                //   // );
                //   // let selectedValueIndex = localFilterList[index].dropDownList.findIndex(
                //   //   (x: IFilterlist) => x.value === finalFilterState[filterKey]
                //   // );
                //   // let selectedObj =
                //   //   localFilterList[index].dropDownList[selectedValueIndex];
                //   setDisplayBubbleFilters((prevState) => {
                //     let tempArr: any = [];
                //     if (!isExpiry) {
                //       tempArr = [...prevState];
                //     }
                //     let isItemPresentInBubbles = tempArr.findIndex(
                //       (bubbleObj) => bubbleObj.name === item.name
                //     );
                //     if (isItemPresentInBubbles < 0) {
                //       tempArr.push(item);
                //     }
                //     tempArr=[...tempArr,expiryFilters[Number(finalFilterState?.expiryId)]]
                //     // tempArr.push({
                //     //   id: parseInt(finalFilterState[filterKey]),
                //     //   name:
                //     //     isExpiry !== null &&
                //     //     isExpiry !== undefined &&
                //     //     isExpiry !== "" &&
                //     //     isExpiry === "true"
                //     //       ? "This Week"
                //     //       : selectedObj !== null && selectedObj !== undefined
                //     //       ? selectedObj.title
                //     //       : finalFilterState[filterKey] === "4"
                //     //       ? "Expired"
                //     //       : "",
                //     //   parentFilter:
                //     //     isExpiry !== null &&
                //     //     isExpiry !== undefined &&
                //     //     isExpiry !== "" &&
                //     //     isExpiry === "true"
                //     //       ? (EnumSalesFilter.expiryId as EnumSalesFilter)
                //     //       : (localFilterList[index].value as EnumSalesFilter),
                //     //   inputType: "dropdown",
                //     //   checked: true,
                //     // });
                //     console.log("tempArr", tempArr);
                //     return tempArr;
                //   });
            }
            else if (filterKey === EnumSalesFilter.sourceId &&
                ((_a = finalFilterState[filterKey]) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                if (!finalFilterState[EnumSalesFilter.sourceIdLst]) {
                    var index = localFilterList.findIndex(function (x) { return x.value === filterKey; });
                    var selectedSource_1 = localFilterList[index].dropDownList.find(function (x) { return x.value === finalFilterState[filterKey][0].toString(); });
                    setDisplayBubbleFilters(function (prevState) { return __spreadArray(__spreadArray([], __read(prevState), false), [
                        {
                            id: finalFilterState[filterKey][0],
                            name: selectedSource_1 === null || selectedSource_1 === void 0 ? void 0 : selectedSource_1.title,
                            parentFilter: EnumSalesFilter.sourceId,
                            inputType: "dropdown",
                            checked: true,
                        },
                    ], false); });
                }
            }
        });
    };
    var onSubmit = function (newFilterState, apply) {
        if (newFilterState === void 0) { newFilterState = finalFilterState; }
        setResetAllMonth(false);
        setDisplayBubbleFilters([]);
        if ((!criticalActivity && !isExpiry && !independentFlag360) || apply) {
            // if (apply) {
            expired = "";
            encodedFilterData = "";
            setIsExpiry(null);
            setTabFlag(null);
            navigate("/dashboard/lead-dashboard", { replace: true });
            // }
            setFilterLoader(true);
            setFinalFilterState(function (finalFilterState) {
                if (!!finalFilterState.expiryId) {
                    if (finalFilterState.expiryId === "1") {
                        finalFilterState.ExpiryfromDate = getDateInFormat(getStartAndEndDates("day").startDate, "YYYY/MM/DD");
                        finalFilterState.ExpirytoDate = getDateInFormat(getStartAndEndDates("day").endDate, "YYYY/MM/DD");
                    }
                    else if (finalFilterState.expiryId === "2") {
                        //week will use for the from start sunday to saturday and isoWeek will use for the from start monday to sunday.
                        finalFilterState.ExpiryfromDate = getDateInFormat(getStartAndEndDates("isoWeek").startDate, "YYYY/MM/DD");
                        finalFilterState.ExpirytoDate = getDateInFormat(getStartAndEndDates("isoWeek").endDate, "YYYY/MM/DD");
                    }
                    else if (finalFilterState.expiryId === "3") {
                        finalFilterState.ExpiryfromDate = getDateInFormat(getStartAndEndDates("month").startDate, "YYYY/MM/DD");
                        finalFilterState.ExpirytoDate = getDateInFormat(getStartAndEndDates("month").endDate, "YYYY/MM/DD");
                    }
                    else {
                        finalFilterState.ExpiryfromDate = "";
                        finalFilterState.ExpirytoDate = "";
                    }
                }
                displayBubbles(newFilterState);
                // filterDI.filter.updateFinalFilterState(finalFilterState);
                return finalFilterState;
            });
            // displayBubbles(finalFilterState);
            setResetShowMonth(false);
            if (!!(finalFilterState === null || finalFilterState === void 0 ? void 0 : finalFilterState.pan) ||
                !!(finalFilterState === null || finalFilterState === void 0 ? void 0 : finalFilterState.mobileNo) ||
                !!(finalFilterState === null || finalFilterState === void 0 ? void 0 : finalFilterState.clientName) ||
                !!(finalFilterState === null || finalFilterState === void 0 ? void 0 : finalFilterState.email) ||
                !!(finalFilterState === null || finalFilterState === void 0 ? void 0 : finalFilterState.leadId)) {
                setFilterSearch(true);
            }
            else {
                setFilterSearch(false);
            }
            setScrollPosition(window.pageYOffset);
            di.leads.paginationResetOnFilterApply(true);
            getLeadDashboardData(flag, false, newFilterState);
            if (closedLead) {
                getLeadDBSummary(LeadTaskStatus.CONVERTED, setleadDBSummaryConverted);
                getLeadDBSummary(LeadTaskStatus.NONCONVERTED, setleadDBSummaryNonConverted);
            }
            else {
                getLeadDBSummary(LeadTaskStatus.OPEN, setleadDBSummaryOpen);
                getLeadDBSummary(LeadTaskStatus.INPROCESS, setleadDBSummaryInProcess);
            }
            setIsShowFilterSidebar(false);
        }
        else {
            setIsShowFilterSidebar(false);
            expired = "";
            encodedFilterData = "";
            setIsExpiry(null);
            setTabFlag(null);
            resetFunction(true);
            // applyFiltersAfterRemovingExpiryFilter();
        }
    };
    var _11 = __read(React.useState(false), 2), closedLead = _11[0], setClosedLead = _11[1];
    function getLeadDBSummary(status, setstate) {
        var filterData = {};
        if (finalFilterState.fromDate && finalFilterState.toDate) {
            filterData.fromDate = finalFilterState.fromDate;
            filterData.toDate = finalFilterState.toDate;
        }
        var payload1 = {
            filterData: filterData,
            status: status.replace(" ", ""),
        };
        di.leads
            .getLeadDBSummaryActions(payload1)
            .then(function (res) {
            setstate(res);
            setFilterLoader(false);
        })
            .catch(function () {
            setFilterLoader(false);
        });
        // if (leadDBSummary) {
        //   setstate(leadDBSummaryEntity);
        //   setFilterLoader(false);
        // } else {
        //   setFilterLoader(false);
        // }
    }
    var _12 = __read(React.useState(), 2), leadDBSummaryOpen = _12[0], setleadDBSummaryOpen = _12[1];
    var _13 = __read(React.useState(), 2), leadDBSummaryInProcess = _13[0], setleadDBSummaryInProcess = _13[1];
    var _14 = __read(React.useState(), 2), leadDBSummaryConverted = _14[0], setleadDBSummaryConverted = _14[1];
    var _15 = __read(React.useState(), 2), leadDBSummaryNonConverted = _15[0], setleadDBSummaryNonConverted = _15[1];
    var payload1 = {
        filterData: finalFilterState,
        status: "Converted",
    };
    var payload2 = {
        filterData: finalFilterState,
        status: "NonConverted",
    };
    var leadDBSummary = useSelector(function (state) {
        return state.Lead.LeadDBSummary.leadDBSummaryList.data
            ? state.Lead.LeadDBSummary.leadDBSummaryList.data
            : [];
    });
    React.useEffect(function () {
        getLeadDBSummary(LeadTaskStatus.OPEN, setleadDBSummaryOpen);
        getLeadDBSummary(LeadTaskStatus.INPROCESS, setleadDBSummaryInProcess);
    }, []);
    var getPartnerList = function (list, searchText) {
        return filterDi.filter.getPartnersListOfLoggedInFRM({
            filterData: __assign({}, list),
            page: 1,
            pageSize: 1000,
            searchText: searchText !== null && searchText !== void 0 ? searchText : "",
        });
    };
    var getFilterDataApis = function (value, searchText, displayId, reqPayload, list) {
        var _a, _b, _c, _d;
        switch (value) {
            case "scheme":
                return filterDi.filter.getSubCategoryAll({
                    page: "1",
                    pageSize: "500",
                });
            case "displayId":
                return filterDi.filter.getDisplaySchemeData({
                    searchText: searchText,
                    displayId: displayId && displayId.length > 0 ? displayId[0] : 0,
                    page: 1,
                    pageSize: 100,
                });
            case "custType":
                return filterDi.filter.getFilterCustomerType({
                    page: "1",
                    pageSize: "100",
                });
            case "mode":
                return filterDi.filter.getFilterTypeOfContact({
                    page: "1",
                    pageSize: "100",
                });
            case "bucketId":
                return filterDi.filter.getBucketDataActions({
                    page: "1",
                    pageSize: "100",
                });
            case "productId":
                return di.leads.getProductNames({
                    page: "1",
                    pageSize: "100",
                    searchText: searchText,
                    bucketlst: ((_a = finalFilterState === null || finalFilterState === void 0 ? void 0 : finalFilterState.bucketId) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                        finalFilterState.bucketId.map(function (record) {
                            return record.toString();
                        }),
                });
            case "status":
                return filterDi.filter.getLeadStatus({
                    page: "1",
                    pageSize: "100",
                });
            case "interactionStatus":
                return filterDi.filter.getInteractionStatusData({
                    page: "1",
                    pageSize: "100",
                });
            case "sourceId":
                return filterDi.filter
                    .getSourceData({ page: "1", pageSize: "50" })
                    .then(function (sourceData) {
                    return { filterData: sourceData.sourceList };
                });
            case "subSourceId":
                if (((_b = finalFilterState[EnumSalesFilter.sourceId]) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    return filterDi.filter.getSubSourceDataForMultipleSources({
                        page: "1",
                        pageSize: "100",
                        sourceId: finalFilterState[EnumSalesFilter.sourceId][0],
                    });
                }
                break;
            case "interactionSubStatus":
                if (((_c = finalFilterState === null || finalFilterState === void 0 ? void 0 : finalFilterState.interactionStatus) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                    var reqObj = {
                        page: "1",
                        pageSize: "100",
                        statusid: null,
                        interactionStatusId: finalFilterState.interactionStatus,
                    };
                    return filterDi.filter.getInteractionStatusData(reqObj);
                }
                break;
            case "categoryId":
                return di.leads.getCategoryMasterData({
                    page: 1,
                    pageSize: 100,
                    searchText: searchText,
                    Product: ((_d = finalFilterState === null || finalFilterState === void 0 ? void 0 : finalFilterState.productId) === null || _d === void 0 ? void 0 : _d.length) > 0 &&
                        finalFilterState.productId.map(function (record) {
                            return record.toString();
                        }),
                });
            case "partnerId":
                return getPartnerList(list, searchText);
        }
    };
    var getLeadDashboardData = function (flag, isDownload, filterData, shouldDateSkip, isExpiry, pageNumber) {
        if (isDownload === void 0) { isDownload = false; }
        setFinalFilterState(function (finalFilterState) {
            filterDI.filter.updateFinalFilterState(filterData ? filterData : finalFilterState);
            if (isDownload) {
                setDownloadLoader(true);
            }
            setShowAllOpenLeads(function (showAllOpenLeads) {
                if (showAllOpenLeads) {
                    finalFilterState.showAllOpenLeads = true;
                }
                else {
                    finalFilterState.showAllOpenLeads = false;
                }
                return showAllOpenLeads;
            });
            var payloadLeadDB = {
                filterData: filterData ? filterData : finalFilterState,
                flag: flag,
                isDownload: isDownload,
                page: firstapiCall || di.leads.paginationReset
                    ? "1"
                    : pageNumber === null || pageNumber === void 0 ? void 0 : pageNumber.toString(),
                pageSize: firstapiCall
                    ? leadDashboardInitialPageSize.toString()
                    : leadDashboardPageSize.toString(),
                isExpiry: isExpiry,
                isDateSkip: shouldDateSkip ? shouldDateSkip : isDateSkip === "true",
            };
            if (isDownload) {
                payloadLeadDB.page = "1";
                di.leads
                    .downloadLeadDashboardData(payloadLeadDB)
                    .then(function (leadResponse) {
                    setDownloadLoader(false);
                    base64toExcel(leadResponse, "Lead_Dashboard_Details_" +
                        getDateInFormat(new Date(), "DD_MM_YYYY") +
                        ".csv");
                })
                    .catch(function (resp) {
                    setDownloadLoader(false);
                });
            }
            else {
                if (firstapiCall || di.leads.paginationReset) {
                    di.leads.getLeadDashboarData(payloadLeadDB, shouldDateSkip);
                    setfirstapiCall(false);
                    di.leads.paginationResetOnFilterApply(false);
                }
                else if (!firstapiCall && leadDetails)
                    di.leads.getLeadDashboarData(payloadLeadDB, shouldDateSkip, leadDetails.leadDashboardList);
            }
            return finalFilterState;
        });
    };
    var leadDetails = useSelector(function (state) {
        return state.Lead.LeadDashboard.reducersData.leadDashboardEntity;
    });
    var leadDashboardCommonData = useSelector(function (state) { return state.Lead.LeadDashboard.commonData; });
    var resetFunction = function (callApi) {
        if (skipUpdateUrl || callApi) {
            navigate("/dashboard/lead-dashboard", { replace: true });
        }
        setClosedLead(false);
        if (firstapiCall) {
            setShowAllOpenLeads(true);
        }
        else
            setShowAllOpenLeads(false);
        di.leads.paginationResetOnFilterApply(true);
        setResetShowMonth(true);
        setIsShowFilterSidebar(false);
        setFinalFilterState({});
        setDisplayBubbleFilters([]);
        setLocalFilterList(function (localFilterList) {
            localFilterList = localFilterList.map(function (x) {
                if (x.value !== EnumSalesFilter.followupCount) {
                    x.dropDownList = [];
                }
                return x;
            });
            return localFilterList;
        });
        setDates({
            fromDate: getDateInFormat(moment().startOf("month").toDate(), "YYYY/MM/DD"),
            toDate: getDateInFormat(moment().endOf("month").toDate(), "YYYY/MM/DD"),
        });
        var localFinalFilterState = {
            fromDate: getDateInFormat(moment().startOf("month").toDate(), "YYYY/MM/DD"),
            toDate: getDateInFormat(moment().endOf("month").toDate(), "YYYY/MM/DD"),
            status: 
            // closedLead
            //   ? [
            //       leadStatusConfig.convertedStatusIdForLeadFilter,
            //       leadStatusConfig.nonConvertedStatusIdForLeadFilter,
            //     ]
            //   :
            [
                leadStatusConfig.openStatusIdForLeadFilter,
                leadStatusConfig.inProcessStatusIdForLeadFilter,
            ],
            isCommented: false,
            teamType: [1],
        };
        if (!!isRHAbove && (isRHAbove === null || isRHAbove === void 0 ? void 0 : isRHAbove.length) > 0 && isRHAbove === "Y") {
            localFinalFilterState.teamType = [1, 2];
        }
        localFinalFilterState.isUncalledLeads = false;
        localFinalFilterState.statusLst = [];
        localFinalFilterState.teamTypeLst = [];
        initialDisplayBubbles(localFinalFilterState, true);
        // setFinalFilterState(localFinalFilterState);
        // getLeadDashboardData(flag, false, localFinalFilterState);
        // if (closedLead) {
        //   getLeadDBSummary(LeadTaskStatus.CONVERTED, setleadDBSummaryConverted);
        //   getLeadDBSummary(
        //     LeadTaskStatus.NONCONVERTED,
        //     setleadDBSummaryNonConverted
        //   );
        // } else {
        // setClosedLead(false);
        // getLeadDBSummary(LeadTaskStatus.OPEN, setleadDBSummaryOpen);
        // getLeadDBSummary(LeadTaskStatus.INPROCESS, setleadDBSummaryInProcess);
        // }
    };
    var onShowAllLeads = function (checked) {
        setFilterLoader(true);
        setDisplayBubbleFilters([]);
        setClosedLead(false);
        setShowAllOpenLeads(checked);
        setFinalFilterState(function (finalFilterState) {
            if (checked) {
                finalFilterState = {};
                finalFilterState.teamType = [1];
                finalFilterState.teamTypeLst = [
                    {
                        id: leadStatusConfig.selfTeamObject.id,
                        parentFilter: EnumSalesFilter.teamType,
                        checked: true,
                        inputType: "checkbox",
                        filterKey: EnumSalesFilter.teamTypeLst,
                        name: leadStatusConfig.selfTeamObject.name,
                    },
                ];
                setResetAllMonth(false);
                finalFilterState.status = [];
                finalFilterState.showAllOpenLeads = true;
                setResetAllMonth(false);
                finalFilterState.status = [
                    leadStatusConfig.openStatusIdForLeadFilter,
                    leadStatusConfig.inProcessStatusIdForLeadFilter,
                ];
                finalFilterState.statusLst = [];
                finalFilterState.statusLst.push({
                    id: leadStatusConfig.openStatusIdForLeadFilter,
                    parentFilter: EnumSalesFilter.status,
                    checked: true,
                    inputType: "checkbox",
                    filterKey: EnumSalesFilter.statusLst,
                    name: leadStatusConfig.openStatusIdObject.name,
                });
                finalFilterState.statusLst.push({
                    id: leadStatusConfig.inProcessStatusIdForLeadFilter,
                    parentFilter: EnumSalesFilter.status,
                    checked: true,
                    inputType: "checkbox",
                    filterKey: EnumSalesFilter.statusLst,
                    name: leadStatusConfig.inProcessStatusIdObject.name,
                });
                /* commented for the sometime by pranav */
                // setDates((dates) => {
                //   dates.fromDate = getDateInFormat(
                //     getBackMonths(TodaysDate, 3),
                //     "YYYY/MM/DD"
                //   );
                //   dates.toDate = getDateInFormat(new Date(), "YYYY/MM/DD");
                //   return dates;
                // });
                // finalFilterState.fromDate = getDateInFormat(
                //   getBackMonths(TodaysDate, 3),
                //   "YYYY/MM/DD"
                // );
                // finalFilterState.toDate = getDateInFormat(new Date(), "YYYY/MM/DD");
            }
            else {
                var fromDate = getDateInFormat(moment().startOf("month").toDate(), "YYYY/MM/DD"), toDate = getDateInFormat(moment().endOf("month").toDate(), "YYYY/MM/DD");
                setDates({ fromDate: fromDate, toDate: toDate });
                finalFilterState.fromDate = fromDate;
                finalFilterState.toDate = toDate;
                finalFilterState.showAllOpenLeads = false;
                setResetAllMonth(true);
                //resetFunction();
            }
            displayBubbles(finalFilterState);
            getLeadDBSummary(LeadTaskStatus.OPEN, setleadDBSummaryOpen);
            getLeadDBSummary(LeadTaskStatus.INPROCESS, setleadDBSummaryInProcess);
            getLeadDashboardData(flag, false, finalFilterState, false, false, 1);
            return finalFilterState;
        });
    };
    var onClosed = function (checked) {
        if (checked) {
            setShowAllOpenLeads(false);
        }
        setDisplayBubbleFilters([]);
        setFinalFilterState(function (finalFilterState) {
            if (!!finalFilterState.expiryId) {
                if (finalFilterState.expiryId === "1") {
                    finalFilterState.ExpiryfromDate = getDateInFormat(getStartAndEndDates("day").startDate, "YYYY/MM/DD");
                    finalFilterState.ExpirytoDate = getDateInFormat(getStartAndEndDates("day").endDate, "YYYY/MM/DD");
                }
                else if (finalFilterState.expiryId === "2") {
                    //week will use for the from start sunday to saturday and isoWeek will use for the from start monday to sunday.
                    finalFilterState.ExpiryfromDate = getDateInFormat(getStartAndEndDates("isoWeek").startDate, "YYYY/MM/DD");
                    finalFilterState.ExpirytoDate = getDateInFormat(getStartAndEndDates("isoWeek").endDate, "YYYY/MM/DD");
                }
                else if (finalFilterState.expiryId === "3") {
                    finalFilterState.ExpiryfromDate = getDateInFormat(getStartAndEndDates("month").startDate, "YYYY/MM/DD");
                    finalFilterState.ExpirytoDate = getDateInFormat(getStartAndEndDates("month").endDate, "YYYY/MM/DD");
                }
            }
            return finalFilterState;
        });
        setScrollPosition(window.pageYOffset);
        di.leads.paginationResetOnFilterApply(true);
        setFinalFilterState(function (finalFilterState) {
            finalFilterState.status = [];
            return finalFilterState;
        });
        setClosedLead(checked);
        if (checked) {
            setFinalFilterState(function (finalFilterState) {
                finalFilterState.status = [
                    leadStatusConfig.convertedStatusIdForLeadFilter,
                    leadStatusConfig.nonConvertedStatusIdForLeadFilter,
                ];
                finalFilterState.statusLst = [];
                finalFilterState.statusLst.push({
                    id: leadStatusConfig.convertedStatusIdForLeadFilter,
                    parentFilter: EnumSalesFilter.status,
                    checked: true,
                    inputType: "checkbox",
                    filterKey: EnumSalesFilter.statusLst,
                    name: leadStatusConfig.convertedStatusIdObject.name,
                });
                finalFilterState.statusLst.push({
                    id: leadStatusConfig.nonConvertedStatusIdForLeadFilter,
                    parentFilter: EnumSalesFilter.status,
                    checked: true,
                    inputType: "checkbox",
                    filterKey: EnumSalesFilter.statusLst,
                    name: leadStatusConfig.notConvertedStatusIdObject.name,
                });
                displayBubbles(finalFilterState);
                return finalFilterState;
            });
            getLeadDBSummary(LeadTaskStatus.CONVERTED, setleadDBSummaryConverted);
            getLeadDBSummary(LeadTaskStatus.NONCONVERTED, setleadDBSummaryNonConverted);
            getLeadDashboardData(flag);
        }
        else {
            setFinalFilterState(function (finalFilterState) {
                finalFilterState.status = [
                    leadStatusConfig.openStatusIdForLeadFilter,
                    leadStatusConfig.inProcessStatusIdForLeadFilter,
                ];
                finalFilterState.statusLst = [];
                finalFilterState.statusLst.push({
                    id: leadStatusConfig.openStatusIdForLeadFilter,
                    parentFilter: EnumSalesFilter.status,
                    checked: true,
                    inputType: "checkbox",
                    filterKey: EnumSalesFilter.statusLst,
                    name: leadStatusConfig.openStatusIdObject.name,
                });
                finalFilterState.statusLst.push({
                    id: leadStatusConfig.inProcessStatusIdForLeadFilter,
                    parentFilter: EnumSalesFilter.status,
                    checked: true,
                    inputType: "checkbox",
                    filterKey: EnumSalesFilter.statusLst,
                    name: leadStatusConfig.inProcessStatusIdObject.name,
                });
                displayBubbles(finalFilterState);
                // filterDI.filter.updateFinalFilterState(finalFilterState);
                return finalFilterState;
            });
            getLeadDBSummary(LeadTaskStatus.OPEN, setleadDBSummaryOpen);
            getLeadDBSummary(LeadTaskStatus.INPROCESS, setleadDBSummaryInProcess);
            getLeadDashboardData(flag);
        }
        if (encodedFilterData || expired || independentFlag360) {
            navigate("/dashboard/lead-dashboard", { replace: true });
            expired = "";
            encodedFilterData = "";
            setIsExpiry(null);
            setTabFlag(null);
        }
    };
    var getCurretPageLeads = function (pageNumber) { return __awaiter(void 0, void 0, void 0, function () {
        var table;
        return __generator(this, function (_a) {
            if (isExpiry === "true") {
                //di.leads.paginationResetOnFilterApply(true);
                getLeadDashboardData("2", false, null, false, isExpiry ? true : false, pageNumber);
            }
            else {
                getLeadDashboardData(flag, false, null, isDateSkip === "true", false, pageNumber);
            }
            table = document.getElementById("lead-table");
            // Scroll to the top position of the table
            if (table) {
                table.scrollIntoView({ behavior: "smooth", block: "start" });
            }
            return [2 /*return*/];
        });
    }); };
    // scrolling shifted to pagination
    // const handleScroll = () => {
    //   const bottom =
    //     Math.ceil(window.innerHeight + window.scrollY) >=
    //     document.documentElement.scrollHeight;
    //   if (
    //     bottom &&
    //     leadDetails?.leadDashboardList &&
    //     leadDetails?.currentpage < leadDetails?.totalpages
    //   ) {
    //     const position = window.pageYOffset;
    //     setScrollPosition(position);
    //     if (isExpiry === "true") {
    //       //di.leads.paginationResetOnFilterApply(true);
    //       getLeadDashboardData("2", false, null, false, isExpiry ? true : false);
    //     } else {
    //       getLeadDashboardData(flag);
    //     }
    //   }
    // };
    // React.useEffect(() => {
    //   console.log("leadDetails=", leadDetails);
    //   if (
    //     leadDetails &&
    //     leadDetails.leadDashboardList &&
    //     leadDetails.leadDashboardList?.length > 0
    //   )
    //     window.addEventListener("scroll", handleScroll, {
    //       passive: true,
    //     });
    //   window.scrollTo({ top: scrollPosition });
    //   return () => {
    //     window.removeEventListener("scroll", handleScroll);
    //   };
    // }, [leadDetails]);
    useEffect(function () {
        // if (resetfilter) filterDI.filter.updateFinalFilterState(finalFilterState);
        return function () {
            filterList = filterList.map(function (x) {
                return __assign(__assign({}, x), { dropDownList: [] });
            });
        };
    });
    var refreshLeadDashboard = function () {
        di.leads.paginationResetOnFilterApply(true);
        onClosed(closedLead);
        // getLeadDashboardData(flag);
    };
    var refreshAssingLeadDashboard = function () {
        navigate("/dashboard/lead-dashboard", { replace: true });
        di.leads.paginationResetOnFilterApply(true);
        getLeadDashboardData(flag);
    };
    var handleSearchRecord = function (searchRecord) {
        var localLeadDetail = {};
        setInnerSearchText(searchRecord);
        if (searchRecord !== "" &&
            searchRecord !== null &&
            searchRecord !== undefined &&
            leadDetails &&
            leadDetails.leadDashboardList.length > 0) {
            localLeadDetail.leadDashboardList = [];
            leadDetails.leadDashboardList.map(function (leadRecord) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                if (((_a = leadRecord === null || leadRecord === void 0 ? void 0 : leadRecord.leadId) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(searchRecord.toLowerCase())) ||
                    ((_b = leadRecord === null || leadRecord === void 0 ? void 0 : leadRecord.fullname) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(searchRecord === null || searchRecord === void 0 ? void 0 : searchRecord.toLowerCase())) ||
                    ((_c = leadRecord === null || leadRecord === void 0 ? void 0 : leadRecord.uccCode) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(searchRecord === null || searchRecord === void 0 ? void 0 : searchRecord.toLowerCase())) ||
                    ((_d = leadRecord === null || leadRecord === void 0 ? void 0 : leadRecord.customertype) === null || _d === void 0 ? void 0 : _d.toLowerCase().includes(searchRecord === null || searchRecord === void 0 ? void 0 : searchRecord.toLowerCase())) ||
                    ((_e = leadRecord === null || leadRecord === void 0 ? void 0 : leadRecord.categoryName) === null || _e === void 0 ? void 0 : _e.toLowerCase().includes(searchRecord === null || searchRecord === void 0 ? void 0 : searchRecord.toLowerCase())) ||
                    ((_f = leadRecord === null || leadRecord === void 0 ? void 0 : leadRecord.displayName) === null || _f === void 0 ? void 0 : _f.toLowerCase().includes(searchRecord === null || searchRecord === void 0 ? void 0 : searchRecord.toLowerCase())) ||
                    (
                    // leadRecord?.pipeline
                    //   ?.toLowerCase()
                    //   .includes(searchRecord?.toLowerCase()) ||
                    (_g = leadRecord === null || leadRecord === void 0 ? void 0 : leadRecord.status) === null || _g === void 0 ? void 0 : _g.toLowerCase().includes(searchRecord === null || searchRecord === void 0 ? void 0 : searchRecord.toLowerCase())) ||
                    ((_h = leadRecord === null || leadRecord === void 0 ? void 0 : leadRecord.interactionStatus) === null || _h === void 0 ? void 0 : _h.toLowerCase().includes(searchRecord === null || searchRecord === void 0 ? void 0 : searchRecord.toLowerCase())) ||
                    ((_j = leadRecord === null || leadRecord === void 0 ? void 0 : leadRecord.interaction_sub_status) === null || _j === void 0 ? void 0 : _j.toLowerCase().includes(searchRecord === null || searchRecord === void 0 ? void 0 : searchRecord.toLowerCase())) ||
                    ((_k = leadRecord === null || leadRecord === void 0 ? void 0 : leadRecord.followupDate) === null || _k === void 0 ? void 0 : _k.toLowerCase().includes(searchRecord === null || searchRecord === void 0 ? void 0 : searchRecord.toLowerCase())) ||
                    ((_l = leadRecord === null || leadRecord === void 0 ? void 0 : leadRecord.taskDescription) === null || _l === void 0 ? void 0 : _l.toLowerCase().includes(searchRecord === null || searchRecord === void 0 ? void 0 : searchRecord.toLowerCase()))) {
                    localLeadDetail.leadDashboardList.push(leadRecord);
                }
            });
        }
        else {
            localLeadDetail = null;
        }
        setSearchLeadDetail(localLeadDetail);
    };
    var generateLeadDataComponent = function () {
        return (React.createElement(Row, { className: "m-0 lead-data w-100 " },
            React.createElement(LeadData, { title: closedLead ? LeadTaskStatus.CONVERTED : LeadTaskStatus.OPEN, data: closedLead ? leadDBSummaryConverted === null || leadDBSummaryConverted === void 0 ? void 0 : leadDBSummaryConverted.data : leadDBSummaryOpen === null || leadDBSummaryOpen === void 0 ? void 0 : leadDBSummaryOpen.data }),
            React.createElement(LeadData, { title: closedLead ? LeadTaskStatus.NONCONVERTED : LeadTaskStatus.INPROCESS, data: closedLead
                    ? leadDBSummaryNonConverted === null || leadDBSummaryNonConverted === void 0 ? void 0 : leadDBSummaryNonConverted.data
                    : leadDBSummaryInProcess === null || leadDBSummaryInProcess === void 0 ? void 0 : leadDBSummaryInProcess.data })));
    };
    var generateToggleSwitchComponent = function () {
        return (React.createElement("div", { className: "closed-lead-section leaddashboard-toggleswitch" },
            React.createElement(ToggleSwitch, { id: "Closed Leads", name: "Closed Leads", checked: closedLead, onChange: onClosed, switchcolorClass: "midnight-blue", small: true, className: "closed-leads m-0" }),
            React.createElement("label", { className: "DMSanN_14_400 txt_blackOne1" }, "Closed Leads")));
    };
    var generateShowAllLeadsComponent = function () {
        return (React.createElement("div", { className: "closed-lead-section leaddashboard-toggleswitch white-space-nowrap" },
            React.createElement(ToggleSwitch, { id: "Show all Open Leads", name: "Show all Open Leads", checked: showAllOpenLeads, onChange: onShowAllLeads, switchcolorClass: "midnight-blue", small: true, className: "closed-leads m-0" }),
            React.createElement("label", { className: "mgl-5 DMSanN_14_400 txt_blackOne1" }, "Show all Open Leads")));
    };
    return (React.createElement(React.Fragment, null,
        filterLoader && React.createElement(LogoLoader, { className: "lead-logo-loader" }),
        React.createElement(GridContainer, { parentClass: "lead-dashboard-container" },
            React.createElement(Row, { className: "d-flex justify-content-between align-items-center" },
                React.createElement(Col, null,
                    React.createElement("div", { className: "d-flex align-items-center gap-3" },
                        React.createElement(DateCalendar, { resetShowMonth: resetShowMonth ? resetShowMonth : resetAllMonth, setFinalFilterState: setFinalFilterState, monthlyFirst: Boolean((_g = retainedFilterData === null || retainedFilterData === void 0 ? void 0 : retainedFilterData.showMonth) !== null && _g !== void 0 ? _g : true), weeklyFirst: Boolean((_h = retainedFilterData === null || retainedFilterData === void 0 ? void 0 : retainedFilterData.showWeek) !== null && _h !== void 0 ? _h : false), todaysDate: true, fromDate: (retainedFilterData === null || retainedFilterData === void 0 ? void 0 : retainedFilterData.fromDate)
                                ? retainedFilterData === null || retainedFilterData === void 0 ? void 0 : retainedFilterData.fromDate
                                : dates.fromDate, toDate: (retainedFilterData === null || retainedFilterData === void 0 ? void 0 : retainedFilterData.toDate)
                                ? retainedFilterData === null || retainedFilterData === void 0 ? void 0 : retainedFilterData.toDate
                                : dates.toDate, isSkip: isSkip && dates.fromDate !== null && dates.toDate !== null
                                ? true
                                : false, ToDatemax: futureMonth(TodaysDate, 6), isMinDate: true, lastQuarter: true, lastQuarterYear: getFinancialYear(new Date()) - 1, dateChangeFilterData: dateChangeFilterData, skipForFinalYear: true, setEndOfMonth: true, parentClassName: "white-space-nowrap" }),
                        generateShowAllLeadsComponent())),
                React.createElement(Col, null,
                    React.createElement("div", { className: "d-flex justify-content-end align-items-center " },
                        React.createElement(EdButton, { onClick: function () {
                                var currentUrl = window.location.href;
                                var _a = __read(currentUrl.split("?"), 2), baseUrl = _a[0], queryString = _a[1];
                                navigate("/dashboard/leadpage", {
                                    state: {
                                        param: queryString,
                                        leadTableTab: flag,
                                    },
                                });
                                localStorage.setItem(ELocalStorageKeys.RefreshPage, "Y");
                            }, btnTyp: "midnight-blue", value: "Create Lead", className: "create-lead EncodeSans_12_500" })))),
            React.createElement(Row, { className: "filter-sections-container" },
                React.createElement(FilterState, { parentSearchText: (_j = retainedFilterData === null || retainedFilterData === void 0 ? void 0 : retainedFilterData.leadId) !== null && _j !== void 0 ? _j : leadIdSearch, isSearch: true, finalFilterState: finalFilterState, setFinalFilterState: setFinalFilterState, onSubmit: onSubmit, filterList: localFilterList, onSearch: updateInputSearch, getFilterDataApis: getFilterDataApis, showReset: true, resetFunction: function () { return resetFunction(true); }, onSearchIconClick: true, mainSearchValue: (!!(finalFilterState === null || finalFilterState === void 0 ? void 0 : finalFilterState.pan) ||
                        !!(finalFilterState === null || finalFilterState === void 0 ? void 0 : finalFilterState.mobileNo) ||
                        !!(finalFilterState === null || finalFilterState === void 0 ? void 0 : finalFilterState.clientName) ||
                        !!(finalFilterState === null || finalFilterState === void 0 ? void 0 : finalFilterState.email) ||
                        !!(finalFilterState === null || finalFilterState === void 0 ? void 0 : finalFilterState.leadId)) &&
                        !!finalFilterState.isClientRedirected &&
                        finalFilterState.isClientRedirected === "Y"
                        ? finalFilterState.pan
                        : "", isShowNewDesign: isShowNewFilterDesign, displayBubbleFilters: displayBubbleFilters, setDisplayBubbleFilters: setDisplayBubbleFilters, isShowFilterSidebar: isShowFilterSidebar, setIsShowFilterSidebar: setIsShowFilterSidebar, applyFiltersAfterRemovingExpiryFilter: function () { }, propsSearchText: querySearchText, updateLeadDashboardURL: updateLeadDashboardURL }),
                generateToggleSwitchComponent()),
            React.createElement(Row, null, isShowNewFilterDesign && generateLeadDataComponent()),
            React.createElement(Row, { className: "lead-table-conatiner p-0", id: "lead-table" },
                React.createElement("div", { className: "stick-leadView-tabs" },
                    React.createElement(LeadViewTabs, { getLeadDashboardData: getLeadDashboardData, setFlag: setFlag, flag: flag, searchText: innerSearchText, setSearchText: handleSearchRecord, setScrollPosition: setScrollPosition, loader: downloadLoader, skipUpdateUrl: skipUpdateUrl })),
                React.createElement(LeadTableNPagination, { setLeadIdSearch: function (leadId) {
                        setLeadIdSearch(leadId);
                        if (encodedFilterData &&
                            (encodedFilterData === null || encodedFilterData === void 0 ? void 0 : encodedFilterData.length) > 0 &&
                            skipUpdateUrl) {
                            var url = new URL(window.location.href);
                            var params = url.searchParams;
                            params.append("isParenetIdClick", "true");
                            navigate("/dashboard/lead-dashboard?" +
                                new URLSearchParams(params).toString(), { replace: true });
                            //                 navigate(
                            // "dashboard/lead-dashboard"+
                            //                    new URLSearchParams(params).toString(),
                            //                   ,
                            //                   { replace: true }
                            //                 );
                        }
                        updateInputSearch(leadId, true, true);
                    }, leadDetails: !!innerSearchText
                        ? !!searchLeadDetail && (searchLeadDetail === null || searchLeadDetail === void 0 ? void 0 : searchLeadDetail.leadDashboardList)
                            ? searchLeadDetail
                            : {}
                        : leadDetails, loader: leadDashboardCommonData.loader, errorData: leadDashboardCommonData.errorData, leadTabFlag: flag, refreshLeadFunction: refreshLeadDashboard, filterSearch: filterSearch, refreshAssingLeadDashboard: refreshAssingLeadDashboard, getCurretPageLeads: getCurretPageLeads })),
            showSuccess && (React.createElement(SalesToasts, { parentClass: "lead-create-toast", show: showSuccess, setShow: setShowSuccess, position: "middle-center", message: React.createElement("span", { dangerouslySetInnerHTML: { __html: (_k = location === null || location === void 0 ? void 0 : location.state) === null || _k === void 0 ? void 0 : _k.msg } }) })))));
};
export default LeadDashBoard;
